import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 16 17"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M3.612 15.94c-.376.196-.817-.119-.745-.53l.838-4.801-3.55-3.4a.502.502 0 0 1 .285-.86l4.906-.7L7.54 1.28a.517.517 0 0 1 .92 0l2.194 4.368 4.906.7c.421.06.59.569.284.86l-3.55 3.4.839 4.8c.072.412-.369.726-.745.532L8 13.674z",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }